export function useSnackbar() {
  const timerId = useState<NodeJS.Timeout | undefined>(
    'timerId',
    () => undefined,
  )

  const showSnackbar = (message: string, activePopConClass = false) => {
    clearTimeout(timerId.value)
    const $nuxt = document.querySelector('#__nuxt')

    const $snackbar
      = document.querySelector('#snackbar') ?? document.createElement('div')
    $snackbar.id = 'snackbar'
    $snackbar.classList.add('pop-up')

    if (activePopConClass) {
      $snackbar.classList.add('pop-con')
    }

    const $alertBox
      = $snackbar.querySelector('.alert-box') ?? document.createElement('div')
    $alertBox.classList.add('alert-box')
    $alertBox.innerHTML = message

    $snackbar.appendChild($alertBox)
    $nuxt?.appendChild($snackbar)

    // Add show class to trigger fade in animation
    setTimeout(() => {
      $snackbar.classList.add('show')
    }, 100)

    timerId.value = setTimeout(() => {
      // Remove show class to trigger fade out animation
      $snackbar.classList.remove('show')
      setTimeout(() => {
        $snackbar.remove()
      }, 500) // Wait for fade out animation to complete
    }, 1500) // 2000
  }

  return { showSnackbar }
}
